import React from 'react';
import { Product } from 'ai-api/types/purchase';
import { Teacher } from './TeacherCard';
import { formatPrice } from '../../Utils/formatting';

interface PaymentSummaryProps {
    product: Product | null;
    selectedTeacher: Teacher | null;
    selectedDate: Date | null;
    selectedTime: Date | null;
}

const PaymentSummary: React.FC<PaymentSummaryProps> = ({
    product,
    selectedTeacher,
    selectedDate,
    selectedTime
}) => {
    return (
        <div className="payment-summary">
            <h2>Confirm Your Purchase</h2>

            <div className="summary-details">
                <div className="summary-item">
                    <span className="label">Product:</span>
                    <span className="value">{product?.name}</span>
                </div>

                {selectedTeacher && (
                    <div className="summary-item">
                        <span className="label">Teacher:</span>
                        <span className="value">{selectedTeacher.name}</span>
                    </div>
                )}

                {selectedDate && selectedTime && (
                    <div className="summary-item">
                        <span className="label">Session Time:</span>
                        <span className="value">
                            {selectedDate.toLocaleDateString()} at {selectedTime.getHours()}:00
                        </span>
                    </div>
                )}

                <div className="summary-item price">
                    <span className="label">Price:</span>
                    <span className="value">{formatPrice(product?.finalAmount || 0, "IDR")}</span>
                </div>
            </div>
        </div>
    );
};

export default PaymentSummary;